var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    stroke: "#000000",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.52,
    cy: 11.43,
    r: 5.82
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.63,
    cy: 31.6,
    r: 5.82
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.52,
    cy: 50.57,
    r: 5.82
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.16,
    cy: 42.03,
    r: 5.82
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.16,
    cy: 19.27,
    r: 5.82
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.51,
    cy: 29.27,
    r: 4.7
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20.17,
    y1: 16.3,
    x2: 28.9,
    y2: 12.93
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 38.6,
    y1: 15.59,
    x2: 49.48,
    y2: 27.52
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 50.07,
    y1: 36.2,
    x2: 38.67,
    y2: 46.49
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 18.36,
    y1: 24.13,
    x2: 30.91,
    y2: 46.01
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 20.31,
    y1: 44.74,
    x2: 28.7,
    y2: 48.63
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 17.34,
    y1: 36.63,
    x2: 31.37,
    y2: 16.32
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 20.52,
    y1: 21.55,
    x2: 30.34,
    y2: 27.1
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 39.22,
    y1: 29.8,
    x2: 47.81,
    y2: 30.45
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 34.51,
    y1: 33.98,
    x2: 34.52,
    y2: 44.74
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.4fd84ff0.svg";
export { ForwardRef as ReactComponent };